<template>
    <div class="box">
        <el-carousel ref="carousel" class="lunbo" height="1030px" style="min-width: 93.75rem;"
            @current-change="handleCarouselChange">
            <el-carousel-item v-for="item in 3" :key="item">
                <img src="../../static/index-ywbk-banner.png" style="width: 100%;height: 100%;" />
            </el-carousel-item>
        </el-carousel>
        <div class="news">
            <div class="newsleft">
                <div class="leftpic">
                    <img src="../../static/Business _segments.png" style="height: 80px;" />
                </div>
                <div class="leftpic1">
                    <img src="../../static/icon-line-light.png" style="width: 100%; height: 100%" />
                </div>
                <div class="leftTitle">业务板块</div>
                <div class="tabs">
                    <div v-for="item in classList" :key="item.dictSort" @click="tabChange(item)">
                        <p :class="{ active: tabIndex == item.dictSort }">{{ item.dictLabel }}</p>
                        <div v-if="tabIndex == item.dictSort" class="line"></div>
                    </div>
                </div>
                <div class="jia" @click="jumpList">
                    <img src="../../static/icon-jia-light.png" style="width: 100%; height: 100%" />
                </div>
            </div>
            <div class="btn-box" style="margin-top: 450px;">
                <img src="../../static/icon-arrow-right-bg.png" @click="goToSlide('prev')"
                    style="cursor: pointer;width: 50px;display: block;margin-bottom: 25px;">
                <img src="../../static/icon-arrow-left-bg.png" @click="goToSlide('next')"
                    style="cursor: pointer;width: 50px;">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'nextNews',
    data() {
        return {
            tabIndex: 0,
            classList: [],
            list: [],
            secondList: [],
            treeList: [],
            fistCount: {},
            queryParams: {
                pageSize: 10,
                pageNum: 1,
                classify: ""
            },
            carouselInd: 0
        }
    },
    created() {
        this.getClass()
    },
    methods: {
        // 跳转文章列表
        jumpList() {
            this.$router.push({
                path: "/business", query: {
                    type: 'ywbk',
                    tabInd: 3
                }
            });
        },
        handleCarouselChange(newIndex) {
            this.carouselInd = newIndex
        },
        goToSlide(type) {
            if (type == 'prev') {
                this.$refs.carousel.setActiveItem(this.carouselInd--);
            }
            if (type == 'next') {
                this.$refs.carousel.setActiveItem(this.carouselInd++);
            }
        },
        tabChange(row) {
            this.tabIndex = row.dictSort
        },
        getClass() {
            this.$api.getBusinessClassify().then(res => {
                this.classList = res.data.length != 0 ? res.data : res.data
                this.tabIndex = res.data.length != 0 ? res.data[0].dictSort : 0
            })
        },
    },
}
</script>

<style lang="less"scoped>
.active {
    font-weight: 600;
    font-size: 20px;
    color: #fff;
}

.box {
    position: relative;
}

.news {
    position: absolute;
    left: 50%;
    top: 0;
    margin: 0 auto;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 100px 6.5rem;
    min-width: 93.75rem
        /* 1500/16 */
    ;
    width: 93.75rem;
    z-index: 9999;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;

    .newsleft {
        margin-right: 150px;

        .leftpic {
            width: 170px;
            height: 95px;
            // margin-bottom: 30px;
        }

        .leftpic1 {
            width: 89px;
            margin-top: 31px;
            margin-bottom: 60px;
        }

        .leftTitle {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 35px;
            color: #FFF;
            line-height: 0px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .tabs {
            margin-top: 154px;
            margin-bottom: 139px;
        }

        .line {
            width: 80px;
            height: 2px;
            background: #fff;
            border-radius: 0px 0px 0px 0px;
        }

        .tabs div {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 20px;
            color: #FFF;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 38px;
            cursor: pointer;
        }

        .jia {
            width: 50px;
            height: 50px;
            cursor: pointer;
        }
    }

}
</style>
